
































































































































































































































































































































































































































































































































































































































































































































































































































































import {computed, defineComponent, reactive, ref} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import CalculationInput from '../inputs/CalculationInput.vue';
import LatexNumber from '@/tasks/components/displayers/LatexNumber.vue';
import i18n from '@/locales/composables/i18n';
import {frUOttawaLabPeerAssessment} from '@/locales/fr/tasks/UOttawa/frUOttawaLabPeerAssessment';
import {enUOttawaLabPeerAssessment} from '@/locales/en/tasks/UOttawa/enUOttawaLabPeerAssessment';

export default defineComponent({
  name: 'UOttawaLabPeerAssessmentFr',
  components: {
    StembleLatex,
    CalculationInput,
    LatexNumber,
  },
  mixins: [DynamicQuestionMixin()],
  setup() {
    i18n.mergeLocaleMessage('fr', frUOttawaLabPeerAssessment);
    i18n.mergeLocaleMessage('en', enUOttawaLabPeerAssessment);

    const inputs = reactive({
      numberOfPartners: null,
      self: {
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
      partner1: {
        name: null,
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
      partner2: {
        name: null,
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
      partner3: {
        name: null,
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
      partner4: {
        name: null,
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
      partner5: {
        name: null,
        grades: {
          gradeA: null,
          gradeB: null,
          gradeC: null,
          gradeD: null,
          gradeE: null,
          gradeF: null,
          gradeG: null,
          gradeH: null,
          gradeI: null,
        },
      },
    });

    const numberOfPartners = computed(() => {
      if (inputs.numberOfPartners !== null) {
        return inputs.numberOfPartners;
      } else {
        return 0;
      }
    });

    const partner1Name = computed(() => {
      if (inputs.partner1.name !== null) {
        return inputs.partner1.name;
      }
      return '1.';
    });

    const partner2Name = computed(() => {
      if (inputs.partner2.name !== null) {
        return inputs.partner2.name;
      }
      return '2.';
    });

    const partner3Name = computed(() => {
      if (inputs.partner3.name !== null) {
        return inputs.partner3.name;
      }
      return '3.';
    });

    const partner4Name = computed(() => {
      if (inputs.partner4.name !== null) {
        return inputs.partner4.name;
      }
      return '4.';
    });

    const partner5Name = computed(() => {
      if (inputs.partner5.name !== null) {
        return inputs.partner5.name;
      }
      return '5.';
    });

    const filterAndAggregate = (arr: (string | null)[]) =>
      arr
        .filter((val) => val !== null)
        .map(Number)
        .reduce((sum, value) => sum + value, 0)
        .toString();

    const containsAllNullOrEmptyValues = (arr: (string | null)[]) =>
      Object.values(arr).every((val) => val === null || val === '');

    const totalGradeSelf = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.self.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.self.grades));
    });

    const totalGradePartner1 = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.partner1.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.partner1.grades));
    });

    const totalGradePartner2 = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.partner2.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.partner2.grades));
    });

    const totalGradePartner3 = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.partner3.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.partner3.grades));
    });

    const totalGradePartner4 = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.partner4.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.partner4.grades));
    });

    const totalGradePartner5 = computed(() => {
      if (containsAllNullOrEmptyValues(Object.values(inputs.partner5.grades))) {
        return '';
      }

      return filterAndAggregate(Object.values(inputs.partner5.grades));
    });

    return {
      inputs,
      totalGradeSelf,
      totalGradePartner1,
      totalGradePartner2,
      totalGradePartner3,
      totalGradePartner4,
      totalGradePartner5,
      partner1Name,
      partner2Name,
      partner3Name,
      partner4Name,
      partner5Name,
      numberOfPartners,
    };
  },
});
